import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { useParams, useLocation, NavLink } from "react-router-dom";
import ConvertSvgToComponent from "components/ConvertSvgToComponent";

export default function Footer(props) {
  const { routes, teamNavbar } = props;
  const [linkRoutes, setLinkRoutes] = useState([]);
  const location = useLocation();
  const params = useParams();

  useEffect(() => {
    if (routes !== undefined) {
      const routesData = [...routes]
        .filter((route) => !route.hideFromSidebar)
        .map((route) => {
          route.link = route.path;

          Object.keys(params).forEach((key) => {
            const paramValue = params[key];

            route.link = route.link.replace(`:${key}`, paramValue);
          });

          return route;
        });

      setLinkRoutes(routesData);
    }
  }, [location, params, routes]);

  var links = (
    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
      {linkRoutes.map((prop, key) => {
        return (
          <li className="nav-item" key={key}>
            <NavLink
              style={{ textDecoration: "none" }}
              className={classNames({
                "nav-link": !teamNavbar ? true : false,
                "team-nav-link": teamNavbar ? true : false,
              })}
              key={key}
              to={prop.layout + (prop?.link ?? prop?.path)}
              activeClassName="active"
            >
              {typeof prop.icon === "string" && (
                <ConvertSvgToComponent
                  icon={prop.icon}
                  imageclass="footerIcon"
                />
              )}
              <span className="footerName">{prop.name}</span>
            </NavLink>
          </li>
        );
      })}
    </ul>
  );

  return (
    <footer className="mbl-footer" id="footer">
      {links}
    </footer>
  );
}
